import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";

export type ResumeCitizensAttendancesIndicatorM1Params = PaginationFilter & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	isEvaluated?: boolean;
	ine?: string;
	export?: boolean;
};

export class ResumeCitizenAttendancesIndicatorM1Data {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	healthUnitId?: number = 0;
	healthTeamId: number = 0;
	healthTeamIne: string = "";
	healthTeamName: string = "";
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	totalAttendances: number = 0;
	totalGroupActivities: number = 0;
}

export async function getResumeCitizensAttendancesIndicatorM1({
	uf,
	ibgeCode,
	...params
}: ResumeCitizensAttendancesIndicatorM1Params) {
	const response = await esusApi.get<Paginated<ResumeCitizenAttendancesIndicatorM1Data>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/emulti/m1/resume-citizens-attendances`,
		params
	);
	return response.data ?? new Paginated<ResumeCitizenAttendancesIndicatorM1Data>();
}
